const retrieveUDFD = async (lat, lon, days, address = 'your present location') => {
  return fetch(`https://pbsweather.org/shared/server/udfd.php?lat=${lat}&lon=${lon}&days=${days}`)
  .then(response => response.json())
  .catch(error => console.log(error))
}

const retrieveUDFDHourly = async (lat, lon, hours) => {
  return fetch(`https://pbsweather.org/shared/server/udfd_hourly.php?lat=${lat}&lon=${lon}&hours=${hours}`)
  .then(response => response.json())
  .catch(error => console.log(error))
}

const retrieveMETAR = async (lat, lon, address = 'your present location') => {
  return fetch(`https://pbsweather.org/shared/server/metar.php?lat=${lat}&lon=${lon}`)
  .then(response => response.json())
  .catch(error => console.log(error))
}

const retrieveMETARNearest = async (lat, lon) => {
  return fetch(`https://pbsweather.org/shared/server/metar_nearest.php?lat=${lat}&lon=${lon}`)
  .then(response => response.json())
  .catch(error => console.log(error))
}

const retrieveSunriseSunset = async (lat, lon) => {
  return fetch(`https://pbsweather.org/shared/server/astronomy-sun.php?lat=${lat}&lon=${lon}`)
  .then(response => response.json())
  .catch(error => console.log(error))
}

const retrieveObsAndAstronomy = async (lat, lon) => {
  return retrieveMETARNearest(lat, lon)
    .then(observation => {
      return retrieveSunriseSunset(lat, lon)
        .then(astronomy => {
          return new Promise((resolve, reject) => {
            resolve({ ...observation, ...astronomy})
            reject('Error retrieving and/or combining observation with sunrise and sunset data')
          })
        })
    })
}

const retrieveWeatherSTEM = async () => {
  return fetch('https://pbsweather.org/shared/server/wxstem.php')
  .then(response => response.json())
  .catch(error => console.log(error))
}

export { retrieveUDFD, retrieveMETAR, retrieveWeatherSTEM, 
  retrieveMETARNearest, retrieveSunriseSunset, retrieveObsAndAstronomy, retrieveUDFDHourly };